export default "__VITE_ASSET__d0e6ec3e__"